export default "__VITE_ASSET__CfRPyKZZ__"